module.exports = __webpack_public_path__ + "img/help-me-to-choose.3b5b9ddd.svg";